import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReportsPage } from '../pages/ReportsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/reports' as any)({
    component: ReportsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
